import { type RouteRecordRaw } from 'vue-router'

export const launchOnboardingRouter: RouteRecordRaw[] = [
  {
    component: async () => await import('../views/LaunchOnboardingView.vue'),
    meta: {
      authZ: ({ user }) => user.can('read', 'onboarding'),
      title: 'launch',
    },
    name: 'brand.launch-onboarding',
    path: 'launch-onboarding',
  },
]
